import React,{ Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import T from 'i18n-react';
import Theme from './Theme';

import Main from './components/Main';
import Start from './Start';

import { AccountsModel, RequestAjaxClass } from 'models-lib';
import { MessageBox } from 'component-lib';

//require('./ErrorHandling');

let language = localStorage.getItem('vas_language') != null ? localStorage.getItem('vas_language') : 'de';
if (localStorage.getItem('vas_language') == null)
{
  localStorage.setItem('vas_language','de');
}

let roles = localStorage.getItem('vas_roles_definition');
let rolArr = [{ Rights: [{ Description: "alleKunden", Read: false, Create: false, Edit: false, Delete: false }, { Description: "meineDaten", Read: true, Create: true, Edit: true, Delete: false }, { Description: "alleVerträge", Read: false, Create: false, Edit: false, Delete: false }, { Description: "meineVerträge", Read: true, Create: true, Edit: false, Delete: false }, { Description: "alleKonten", Read: false, Create: false, Edit: false, Delete: false }, { Description: "meinKonto", Read: true, Create: true, Edit: true, Delete: true }, { Description: "Formulare", Read: true, Create: false, Edit: false, Delete: false }], Name: "Schüler", Role: "1" }, 
  { Rights: [{ Description: "alleKunden", Read: true, Create: true, Edit: true, Delete: false }, { Description: "meineDaten", Read: false, Create: false, Edit: false, Delete: false }, { Description: "alleVerträge", Read: true, Create: false, Edit: true, Delete: false }, { Description: "meineVerträge", Read: false, Create: false, Edit: false, Delete: false }, { Description: "alleKonten", Read: true, Create: false, Edit: false, Delete: false }, { Description: "meinKonto", Read: true, Create: false, Edit: true, Delete: false }, { Description: "Formulare", Read: false, Create: false, Edit: false, Delete: false }], Name: "Sachbearbeiter", Role: "3" }, 
  { Rights: [{ Description: "alleKunden", Read: false, Create: false, Edit: false, Delete: false }, { Description: "meineDaten", Read: false, Create: false, Edit: false, Delete: false }, { Description: "alleVerträge", Read: false, Create: false, Edit: false, Delete: false }, { Description: "meineVerträge", Read: false, Create: false, Edit: false, Delete: false }, { Description: "alleKonten", Read: false, Create: false, Edit: false, Delete: false }, { Description: "meinKonto", Read: false, Create: false, Edit: false, Delete: false }, { Description: "Formulare", Read: true, Create: true, Edit: true, Delete: true }], Name: "Schule", Role: "2" },
  { Rights: [{ Description: "alleKunden", Read: true, Create: true, Edit: true, Delete: true }, { Description: "meineDaten", Read: true, Create: true, Edit: true, Delete: true }, { Description: "alleVerträge", Read: true, Create: true, Edit: true, Delete: true }, { Description: "meineVerträge", Read: true, Create: true, Edit: true, Delete: true }, { Description: "alleKonten", Read: true, Create: true, Edit: true, Delete: true }, { Description: "meinKonto", Read: true, Create: true, Edit: true, Delete: true }, { Description: "Formulare", Read: true, Create: true, Edit: true, Delete: true }], Name: "Admin", Role: "99" }];

if (roles == null){
  localStorage.setItem('vas_roles_definition',JSON.stringify(rolArr));
}

let data = require('./i18n/'+ language +'.json');

T.setTexts(data);
var Config = require('./dev_config.json');

class Vas extends Component
{
    //static Copyright = localStorage.getItem("vas_copyright");
    static Copyright = "Copyright © DB NRW";
    //static ApplicationUrl = localStorage.getItem("vas_applicationUrl");
    static ApplicationUrl = "http://localhost:3000";
    static Theme = new Theme();
    //static ApiUrl = localStorage.getItem("vas_apiUrl");
    //static ApiUrl = "https://aboportal-nrw-api.db-bus.com/api"; //-> DBBUS Prod Api-Url für Vertragsanlage auskommentieren
    static ApiUrl = "http://abo-online.sts.local:8084/api"; //-> Lokale Api-Url für Vertragsanlage einkommentieren
    //static ApiUrl = "http://pc-holz/schuelerportal/api";
    //static ApiKey = localStorage.getItem("vas_apiKey");
    static ApiKey = "5567GGH8635B!83GhT!j75%";
    //static Debug = localStorage.getItem("vas_debug");
    static Debug = true;
    static Resources = T.texts;
    static MessageBox;
    static Content = null;
    static Slider = null;
    static Captcha = true;
    static TimeOutTime = 1000;
    static AccountsModel = new AccountsModel([this]);
    static Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
    static isIE = /*@cc_on!@*/false || !!document.documentMode;
    static ShowPaymentValidFrom = false;
    static Config = Config;

    static FormParamsToJsonObjectByForm(id)
    {
      let result= {};
      // eslint-disable-next-line
      $("#"+id).serializeArray().map(function(item) {
        if ( result[item.name] )
        {
          if ( typeof(result[item.name]) === "string" )
          {
            result[item.name] = [item.name];
          }
          result[item.name].push(item.value);
        }
        else
        {
          result[item.name] = item.value;
        }
      });
      return result;
    }

    static Update(observer){
      if(observer === "Logout"){
        Vas.GetView("Order",null,false);
      }
    }

    static Signout()
    {
      Vas.Request.setApiKey(Vas.ApiKey);
        Vas.Request.setApiUrl(Vas.ApiUrl);
        Vas.Request.setErrorHandler(()=>{
            window.location = Vas.ApplicationUrl;
            Vas.clearLocalStorage();
            
        })
        Vas.AccountsModel.SetRequest(Vas.Request);
        Vas.AccountsModel.Logout();

      localStorage.removeItem("Id_CurrentCustomer");
      localStorage.removeItem("Birthdate");
      localStorage.removeItem("Number_CurrentCustomer");
      localStorage.removeItem("SendData")
    }

    static clearLocalStorage(){
      Vas.AccountsModel.clearLocalStorage()
    }

    static ClosePopUps(){
      if (document.getElementById('popupContainer')){
          if (document.getElementById('popupContainer').children.length === 0){
              ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
          } else {
              ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
          }
      
         
      } else {
          if (document.getElementById('messageContainer')){
              if (document.getElementById('messageContainer').children.length === 0){
                  ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
              } else {
                  ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
              }
          }
          
      }
  }

    static GetView(view, params, authorization){

      Vas.ClosePopUps();
      clearTimeout(Vas.Slider);

      if (authorization)
      {
        switch (view)
        {
          case "Home":{
            window.location = "/home";
            break;
          }
          case "Contracts":{
            window.location = "/contracts/"+params.All;
            break;
          }
          case "Account":{
            window.location = "/account";
            break;
          }
          case "Accounts":{
            window.location = "/accounts";
            break;
          }
          case "Customers":{
            window.location = "/customers";
            break;
          }
          case "CustomerCardData":
            //localStorage.setItem("vas_selectedTab","UsernameDataLink");
            window.location = "/customerCard/"+params.Id;
            break;
          case "ContractCardContractData":
            //localStorage.setItem("vas_selectedTab","UsernameDataLink");
            window.location = "/contractCard/"+params.Id+"/"+ params.CustomerId + "/"+params.CustomerName;
            break;
          case "Configuration":{
            window.location = "/configuration";
            break;
          }
          case "DocumentUpload":{
            window.location = "/documentUpload";
            break;
          }
          case "DocumentDownload":{
            window.location = "/documentDownload";
            break;
          }
          case "RoleManagement":{
            window.location = "/roleManagement";
            break;
          }
          case "ChangePassword":
            window.location = "/changePassword";
            break;
          case "ChangePasswordSuccess":
            window.location = "/changePasswordSuccess";
            break;
          case "ActivateEMailSuccess":
            window.location = "/activateEMailSuccess";
            break;
          case "NoPayment" :
            window.location = "/noPayment/"+ params.CustomerId;
            break;
          case "CreatePayment":
            window.location = "/createPayment/" +params.CustomerId +"/"+params.NewContract;
            break;
          case "CreatePaymentSuccess":
            window.location = "/createPaymentSuccess/" + params.CustomerId;
            break;
          case "CreateContract":
            window.location = "/createContract/" + params.CustomerId;
            break;
          case "OrderSuccess":
            window.location = "/createContractSuccess";
            break;
          case "CreateLegalGuardian":
            window.location = "/createLegalGuardian/" +params.CustomerId;
            break;
          case "CreateLegalGuardianSuccess":
            window.location = "/createLegalGuardianSuccess/" +params.CustomerId;
            break;
          case "SchoolHistory":
            window.location = "/schoolHistory";
            break;
          case "ChangeMail":
            window.location = "/changeEmail/" + params.CustomerId + "/" + params.Email;
            break;
          case "ChangeMailSuccess":
                window.location = "/changeEmailSuccess/" + params.CustomerId;
                break;
          case "CustomerDocumentUpload":
            window.location = "/customerDocumentUpload/" + params.CustomerId;
            break;
          case "CustomerDocumentUploadSuccess":
            window.location = "/customerDocumentUploadSuccess/" + params.CustomerId;
            break;
          case "CustomerCertificateUpload":
            window.location = "/customerConfirmationsUpload/" + params.CustomerId;
            break;
          case "CustomerCertificateUploadSuccess":
            window.location = "/customerConfirmationsUploadSuccess/" + params.CustomerId;
            break;
          case "ContractCancel":
            window.location = "/contractCancel/" + params.ContractId;
            break;
          case "ContractCancelSuccess":
            window.location = "/contractCancelSuccess";
            break;
          case "ContractCancelContractCard":
            window.location = "/contractCancel/"  + params.ContractId + "/"+ params.CustomerId  + "/" + params.CustomerName;
            break;
          case "ContractCancelSuccessContractCard":
            window.location = "/contractCancelSuccess/" + params.CustomerId + "/" + params.ContractId + "/" + params.CustomerName;
            break;
          case "ContractEditState":
            window.location = "/contractEditState/" + params.CustomerId + "/" + params.ContractId + "/" + params.CustomerName;
            break;
          case "ContractEditStateSuccess":
            window.location = "/contractEditStateSuccess/" + params.CustomerId + "/" + params.ContractId + "/" + params.CustomerName;
            break;
          case "LossReport":
            window.location = "/lossReport/" + params.CustomerId + "/" + params.ContractId + "/" + params.CustomerName;
            break;
          case "LossReportSuccess":
            window.location = "/lossReportSuccess/" + params.CustomerId + "/" + params.ContractId + "/" + params.CustomerName;
            break;
          case "ErrorOnline":
              window.location = "/errorOnline";
              break;
          default  :
            ReactDOM.unmountComponentAtNode(document.getElementById('root'));
            ReactDOM.render(( <Main />
            ), document.getElementById('root'));
        }
      }
      else
      {
        switch (view)
        {
          case "Order":
            window.location = "/order";
            localStorage.setItem("vas_selectedTab","LoginDataLink");
            break;
          case "Login":
            window.location = "/login";
            localStorage.setItem("vas_selectedTab","LoginDataLink");
            break;
          case "Register":
            window.location = "/register";
            localStorage.setItem("vas_selectedTab","RegisterDataLink");
            break;
          case "OrderSuccess":
            window.location = "/orderSuccess";
            break;
          case "ResetPassword":
            window.location = "/resetPassword";
            break;
          case "ResetPassworsSuccess":
            window.location = "/resetPasswordSuccess";
            break;
          case "ActivateEMailSuccessOffline":
            window.location = "/activateEMailSuccessOffline";
            break;
          case "ActivateSuccess":
            window.location = "/activateSuccess";
            break;
          case "Impressum":
            window.location = "/impressum";
            break;
          case "ErrorOffline":
            window.location = "/errorOffline";
            break;
          case "ErrorLogin":
              window.location = "/error";
              break;
          default:
            ReactDOM.unmountComponentAtNode(document.getElementById('root'));
            ReactDOM.render(( <Start />
            ), document.getElementById('root'));
        }
      }
    }

    static ErrorHandling(error){
      $("#root").css("display", "block");
      $("#progressContainer").css("display", "none");

      if(document.getElementById("btoOrder") !== null){
        document.getElementById("btoOrder").disabled = false;
        $("#btoOrder").removeClass().addClass("extendedButton");
      }

      if(error !== undefined && error !== null){
          if(error.status){
              if (error.status === 400 || error.status === 401 || error.status === 403 || error.status === 500)
              {   

                if(this.Debug == true){
                  console.log(error);

                  let err = JSON.parse(error.responseText);
                  let today = new Date().toLocaleString("de-DE");
                  let errorMessage = "Es ist ein Fehler aufgetreten. Im Weiteren folgen einige Fehlerdetails.;" + today  + ";" + error.status;

                  if(err.ErrorCode != null || err.ErrorCode != undefined){
                    errorMessage += ";" + Number(err.ErrorCode,10);
                  }else{
                    errorMessage += ";---";
                  }

                  if(error.responseJSON){
                    localStorage.setItem("ErrorMessage", errorMessage + ";" + error.responseJSON.Description);
                  } else{
                    localStorage.setItem("ErrorMessage", errorMessage + ";" + error.responseText);
                  }
                }

                  switch (error.status){

                      case 401:{
                          // expired token
                          // Beachten, wenn Kunde eingeloggt ist!
                          //Bei Expired Token ist der responseText nicht gefüllt, darum hier auf statusText 'Expired Token' prüfen
                          if (error.statusText === 'Expired Token'){

                              //Nur, wenn der Kunde eingeloggt ist
                              if (localStorage.getItem('vas_token')){
                                Vas.clearLocalStorage();
                    
                                //Hier Hinweis auf Token Expired in LoalStorage schreiben.
                                //Wenn Hinweis auf Token Expired in LoalStorage vorhanden, dann Hinweis entfernen und Messagebox anzeigen
                                localStorage.setItem("ExpiredToken", "expiredToken");
            
                                Vas.GetView("ErrorLogin",null, false);               
                              } else {
                                Vas.clearLocalStorage();
                                Vas.GetView("ErrorOffline",null,false);
                              }
                          }
                          if (error.responseText){

                              let err = JSON.parse(error.responseText);
                              if (Number(err.ErrorCode,10) !== 3){
                                  Vas.clearLocalStorage();
                                  
                                  Vas.GetView("ErrorLogin",null, false);
                              } else {//Login oder PW falsch
                                if (document.getElementById('LoadingIconPopUp') === null){
                                  ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
                                }
                                else {
                                    $("#LoadingIconPopUp").removeClass().addClass('hide');
                                }
                                
                                Vas.clearLocalStorage();
                                ReactDOM.render(<MessageBox 
                                    AppURL={Vas.ApplicationUrl} 
                                    Title={Vas.Resources.Titles["Error"]} 
                                    Message={err.Description} /> 
                                    , document.getElementById('messageContainer'));
                              }
                          }
                          if(error.responseJSON){
                              if(error.responseJSON.ErrorCode){
                                  if(error.responseJSON.ErrorCode === "2"){
                                      //Nur, wenn der Kunde eingeloggt ist
                                      if (localStorage.getItem('vas_token')){
                                        Vas.clearLocalStorage();
                    
                                        Vas.GetView("ErrorLogin",null, false);              
                                      } else {
                                          Vas.clearLocalStorage();
                                          Vas.GetView("ErrorOffline",null,false);
                                      }
                                  }
                              }
                          }
                          break;
                      }
                      case 500:{
                          if (document.getElementById('LoadingIconPopUp') === null){
                              ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
                          }
                          else {
                              $("#LoadingIconPopUp").removeClass().addClass('hide');
                          }
                          if (error.responseJSON){
                              switch (error.responseJSON.ErrorCode){
                                  case "7":
                                  case "1402":{//Dokument hängt an Nachweis
                                      ReactDOM.render(<MessageBox 
                                      AppURL={Vas.ApplicationUrl} 
                                      Title={Vas.Resources.Titles["Error"]} 
                                      Message={error.responseJSON.Description} /> 
                                      , document.getElementById('messageContainer'));
                                      break;
                                  }
                                  case "2":{// Expired Token
                                      if (localStorage.getItem('vas_token')){
                                          Vas.clearLocalStorage();
                                          //Hier Hinweis auf Token Expired in LoalStorage schreiben.
                                          //Wenn Hinweis auf Token Expired in LoalStorage vorhanden, dann Hinweis entfernen und Messagebox anzeigen
                                          //localStorage.setItem("ExpiredToken", "expiredToken");
                          
                                          Vas.GetView("ErrorLogin",null, false);                
                                      } else {
                                          Vas.clearLocalStorage();
                                          Vas.GetView("ErrorOffline",null,false);
                                      }
                                      break;
                                  }
                                  case "1304":{// Fehler bei der Vertragsanlage, Kunde konnte nicht angelegt werden
                                      Vas.clearLocalStorage();
                                      // if(error.responseJSON.Description){
                                      //     localStorage.setItem('Error', error.responseJSON.Description);
                                      // }
                                      Vas.GetView("ErrorOffline",null,false);
                                      break;
                                  }
                                  case "1305":
                                  case "1600"://zusätzliche Adresse konnte nicht angelegt werden, es gibt bereits einen Datensatz mir dem gleichen Von-Datum {
                                  case "1306":{//Verlustmeldung noch nicht möglich, weil keine Karte ausgegeben wurde.
                                    ReactDOM.render(<MessageBox 
                                      AppURL={Vas.ApplicationUrl}  
                                      Title={Vas.Resources.Titles["Error"]} 
                                      Message={error.responseJSON.Description} /> 
                                      , document.getElementById('messageContainer'));
                                      break;
                                  }
                                  case "17":{//Fehler bei der Bestandskundenregistriereung
                                    ReactDOM.render(<MessageBox 
                                        AppURL={Vas.ApplicationUrl} 
                                        Title={Vas.Resources.Titles["Error"]} 
                                        Message={error.responseJSON.Description} /> 
                                        , document.getElementById('messageContainer'));
                                        break;
                                }
                                case "15":{//Account ist gesperrt
                                    ReactDOM.render(<MessageBox 
                                        AppURL={Vas.ApplicationUrl} 
                                        Title={Vas.Resources.Titles["Error"]} 
                                        Message={Vas.Resources.Labels["AccountBlocked"] !== null && 
                                                Vas.Resources.Labels["AccountBlocked"] !== undefined 
                                                    ? Vas.Resources.Labels["AccountBlocked"] 
                                                    : error.responseJSON.Description} /> 
                                        , document.getElementById('messageContainer'));
                                        break;
                                }
                                case "12":{//Account konnte nicht angelegt werden, da schon vorhanden
                                    ReactDOM.render(<MessageBox 
                                    AppURL={Vas.ApplicationUrl} 
                                    Title={Vas.Resources.Titles["Error"]} 
                                    Message={Vas.Resources.Labels["AccountCreationFailed"] !== null && 
                                            Vas.Resources.Labels["AccountCreationFailed"] !== undefined 
                                                ? Vas.Resources.Labels["AccountCreationFailed"] 
                                                : error.responseJSON.Description} /> 
                                    , document.getElementById('messageContainer'));
                                    break;
                                }
                                  default:{
                                      if (localStorage.getItem('vas_token')){
                                          /*Vas.clearLocalStorage();
                                          //Hier Hinweis auf Token Expired in LoalStorage schreiben.
                                          //Wenn Hinweis auf Token Expired in LoalStorage vorhanden, dann Hinweis entfernen und Messagebox anzeigen
                                          localStorage.setItem("ExpiredToken", "expiredToken");
                          
                                          Vas.GetView("Login",null, false);                  */
                                          //localStorage.setItem('Error', error.responseJSON.Description);
                                          Vas.clearLocalStorage();
                                          Vas.GetView("ErrorOnline",null,true);
                                      } else {
                                          Vas.clearLocalStorage();
                                          //localStorage.setItem('Error', error.responseJSON.Description);
                                          Vas.GetView("ErrorOffline",null,false);
                                      }
                                      break;
                                  }
                              }
                          } else {
                              if (localStorage.getItem('vas_token')){
                                  Vas.clearLocalStorage();
                                  //Hier Hinweis auf Token Expired in LoalStorage schreiben.
                                  //Wenn Hinweis auf Token Expired in LoalStorage vorhanden, dann Hinweis entfernen und Messagebox anzeigen
                                  //localStorage.setItem("ExpiredToken", "expiredToken");
                  
                                  Vas.GetView("ErrorLogin",null, false);                 
                              } else {
                                  Vas.clearLocalStorage();
                                  Vas.GetView("ErrorOffline",null,false);
                              }
                          }
                          break;
                      }
                      default:{
                          if (error.responseJSON)
                          {
                              if (error.responseJSON.info && error.responseJSON.info.message) {
                                  ReactDOM.render(<MessageBox 
                                  AppURL={Vas.ApplicationUrl} 
                                  Title={Vas.Resources.Titles["Error"]} 
                                  Message={error.responseJSON.info.message} /> 
                                      , document.getElementById('messageContainer'));
                              }
                          } else

                          if (error.responseText) {
                              ReactDOM.render(<MessageBox 
                              AppURL={Vas.ApplicationUrl} 
                              Title={Vas.Resources.Titles["Error"]} 
                              Message={error.responseText} /> 
                                  , document.getElementById('messageContainer'));
                          }
                          break;
                      }
                  }
              }
              else
              {
                  if (error.status !== 0)
                  {
                      ReactDOM.render(<MessageBox 
                      AppURL={Vas.ApplicationUrl} 
                      Title={Vas.Resources.Titles["Error"]} 
                      Message={error.responseText} /> 
                          , document.getElementById('messageContainer'));
                  }
                  else
                  {   
                      if(document.getElementById('popupContainer')){
                          ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
                      }
                      
                      ReactDOM.render(<MessageBox 
                      AppURL={Vas.ApplicationUrl} 
                      Title={Vas.Resources.Titles["Error"]} 
                      Message={Vas.Resources.ErrorMessages["ConnectionError"]} /> 
                          , document.getElementById('messageContainer'));
                  }
              }
          }
      }
      
    }
}
export default Vas;
